module.exports = __webpack_public_path__ + "fonts/Vazir.665ee3f.ttf";